import { create } from 'zustand';

type HeaderState = {
    isSticky: boolean;
    isLocked: boolean;
    height: number | null;
    setHeaderIsStickyBool: (bool: boolean) => void;
    toggleHeaderLocked: (bool: boolean) => void;
    setHeaderHeight: (height: number) => void;
};

export const useHeaderStore = create<HeaderState>((set) => ({
    isSticky: false,
    isLocked: false,
    height: null,
    setHeaderIsStickyBool: (bool) => set({ isSticky: bool }),
    toggleHeaderLocked: (bool) => set({ isLocked: bool }),
    setHeaderHeight: (height) => set({ height })
}));
